import { TWclassNames } from "../Div";

/** Rows fetched per search. The panel hints to search when a page is full. */
export const PICKER_PAGE_SIZE = 30;

export const initialsOf = (text) =>
  String(text || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0])
    .join("")
    .toUpperCase() || "?";

/** Stable hue per label so the same customer/contact keeps its colour. */
export const hueOf = (text) => {
  let hue = 0;
  for (const char of String(text || "")) hue = (hue * 31 + char.charCodeAt(0)) % 360;
  return hue;
};

export function InitialsAvatar({ text, square = false }) {
  return (
    <span
      aria-hidden="true"
      className={TWclassNames("pm-picker-avatar", square ? "pm-picker-avatar--square" : "")}
      style={{ background: `oklch(0.62 0.16 ${hueOf(text)})` }}
    >
      {initialsOf(text)}
    </span>
  );
}

export function IconAvatar({ icon: Icon }) {
  return (
    <span aria-hidden="true" className="pm-picker-avatar pm-picker-avatar--square pm-picker-avatar--icon">
      <Icon className="h-4 w-4" />
    </span>
  );
}

export function PickerTag({ children }) {
  return children ? <span className="pm-picker-tag">{children}</span> : null;
}

/** List rows from a Promang index response (`{ data: [...] }`); anything else is a failure. */
export function rowsFrom(response) {
  const payload = response?.data;
  if (payload?.errors && Object.keys(payload.errors).length) throw new Error("Picker request failed");
  if (payload?.data == null) return [];
  if (!Array.isArray(payload.data)) throw new Error("Invalid picker response");
  return payload.data;
}

export const joinParts = (...parts) => parts.filter(Boolean).join(" · ") || null;
